export default "__VITE_ASSET__C8029Shc__"